// extracted by mini-css-extract-plugin
module.exports = {"overlay":"assignments_overlay__5Qgs9","progressBarContainer":"assignments_progressBarContainer__2JuqW","loadingMessage":"assignments_loadingMessage__sdiD0"};